import App from "../../core/src/App";
import { Commands } from "../../core/src/commands/CommandEnum";
import CommandManager from "../../core/src/commands/CommandManager";
import CommManager from "../../core/src/controllers/CommManager";
import AutoplayModel from "../../core/src/model/AutoplayModel";
import BetModel from "../../core/src/model/BetModel";
import ErrorModel from "../../core/src/model/ErrorModel";
import GameModel from "../../core/src/model/GameModel";
import SpinModel from "../../core/src/model/SpinModel";
import RequestRegister from "../../core/src/server/requests/RequestRegister";
import { State } from "../../core/src/states/State";
import UIController from "../../core/src/ui/UIController";
import { DefaultLayers } from "../../core/src/utils/Layers";
import ViewManager from "../../core/src/utils/ViewManager";
import ReelGroup from "../../core/src/views/ReelGroup";
import VendorModel from "../model/VendorModel";
import FConnector from "../server/FConnector";
import { AuthResponse } from "../server/FTypes";

export default class VendorFinishState extends State {
    protected _canExit: boolean = false;

    public async enter() {
        super.enter();
        this._canExit = false;
        const scene = ViewManager.getLayer(
            DefaultLayers.Reels
        ).getCurrentScene();

        // We must show the final syms, only when no winlines/ways will be shown,
        // because this state will be called right after the lines summary.
        if (!SpinModel.hasWinnings()) {
            const reelGroup = scene.getSubView("ReelGroup") as ReelGroup;
            let reels = Array.from(Array(reelGroup.reels.length).keys());
            let result = SpinModel.getFinalSymsForReels(reels);
            reelGroup.showFinalSymbols(result);
        }

        console.log("VendorModel.nextAction: " + VendorModel.nextAction);
        
        if (GameModel.isReplay) {
            const newBalance = { balance: GameModel.replayBalanceAfterWin }
            this.complete(newBalance);
        } else {
            const newBalance = await FConnector.complete();
            this.complete(newBalance);
        }
    }

    public canExit(): boolean {
        // Ensuring that all requests are done, then we allow to exit this state,
        // otherwise the skip chain will scramble the requests order, which leads to error 47
        // ERR_INVALID_SEQUENCE (47)
        return this._canExit;
    }

    private complete(data) {
        this._canExit = true;
        ErrorModel.update(data);
        BetModel.update(data);

        CommandManager.execute(Commands.UPDATE_UI);
        SpinModel.roundFinish = true;
        SpinModel.spinFinished = true;

        this.checkAuto();

        this.exit();
    }

    protected checkAuto(): void {
        if (AutoplayModel.isAutoSpinActive()) {
            if (
                AutoplayModel.checkLossLimitReached() ||
                AutoplayModel.checkWinLimitReached(SpinModel.accumulatedWin) ||
                AutoplayModel.checkTotalWinLimitReached() ||
                AutoplayModel.checkStopOnAnyWin(SpinModel.accumulatedWin) ||
                AutoplayModel.checkStopOnBigWin(SpinModel.accumulatedWin) ||
                AutoplayModel.checkFeatureWin(SpinModel.hasFreespins())
            ) {
                CommandManager.execute(Commands.STOP_AUTOPLAY);
                CommandManager.execute(Commands.CLEAR_AUTOPLAY_LIMITS);
            }
        }
        if (AutoplayModel.autoSpinLimitReached) {
            UIController.toggleComponent("autoplayLimitPopup");
        }
    }
}
